import { render, staticRenderFns } from "./NewInst.vue?vue&type=template&id=b30e74cc&scoped=true"
import script from "./NewInst.vue?vue&type=script&lang=js"
export * from "./NewInst.vue?vue&type=script&lang=js"
import style0 from "./NewInst.vue?vue&type=style&index=0&id=b30e74cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30e74cc",
  null
  
)

export default component.exports